// extracted by mini-css-extract-plugin
export var leaveComment = "leave-comment-form-module--leave-comment--n8KAK";
export var leaveCommentContainer = "leave-comment-form-module--leave-comment-container--gm3DL";
export var leaveCommentForm = "leave-comment-form-module--leave-comment-form--HBf2P";
export var leaveCommentFormButton = "leave-comment-form-module--leave-comment-form-button--NPZAd";
export var leaveCommentFormField = "leave-comment-form-module--leave-comment-form-field--Rpae+";
export var leaveCommentSubtitle = "leave-comment-form-module--leave-comment-subtitle--9m6Pd";
export var leaveCommentTitle = "leave-comment-form-module--leave-comment-title--jEqkT";